var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-stepper-step",
    {
      class: [_vm.$style.step, _vm.StepStyle],
      attrs: {
        step: _vm.currentCategory.orderIndex,
        complete: _vm.currentStep > _vm.currentCategory.orderIndex
      },
      on: {
        click: function($event) {
          return _vm.$emit("stepChange", _vm.currentCategory.orderIndex)
        }
      }
    },
    [
      _c("div", { class: _vm.$style.stepTitleContainer }, [
        _vm.itemSelectedInCategory(_vm.categoryKey)
          ? _c("div", { class: _vm.$style.stepCheckmark }, [
              _c("svg", {
                directives: [{ name: "svg", rawName: "v-svg" }],
                class: _vm.$style.checkmarkIcon,
                attrs: { symbol: "checkmark-icon" }
              })
            ])
          : _c("div", { class: _vm.$style.stepCheckmarkNotValid }, [
              _c("svg", {
                directives: [{ name: "svg", rawName: "v-svg" }],
                class: _vm.$style.checkmarkIcon,
                attrs: { symbol: "checkmark-icon" }
              })
            ]),
        _vm._v(" "),
        _c("h4", { class: _vm.$style.stepTitle }, [
          _vm._v(_vm._s(_vm.currentCategory.name))
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/configurator/components/ConfiguratorStepTitle.vue?vue&type=template&id=1bd8b498&
// module id = null
// module chunks = 